'use client';

import { tsrShared } from '@/libs/ts-rest/ts-rest';
import { createLanguageListQueryOptions } from '@/modules/shared/contracts';
import type { LanguageListQueryOptions } from '@/modules/shared/contracts';

export const useLanguageListQuery = (options?: Partial<LanguageListQueryOptions>) => {
	const queryOptions = createLanguageListQueryOptions();

	return tsrShared.languages.list.useQuery({
		...queryOptions,
		...options,
	});
};
